import { render, staticRenderFns } from "./SalesPointView.vue?vue&type=template&id=33af35c5&scoped=true&"
import script from "./SalesPointView.vue?vue&type=script&lang=js&"
export * from "./SalesPointView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af35c5",
  null
  
)

export default component.exports